import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "onboard-card" }
const _hoisted_2 = { class: "onboard-progress" }
const _hoisted_3 = {
  key: "1",
  class: "onboard-step"
}
const _hoisted_4 = { class: "onboard-checklist" }
const _hoisted_5 = {
  key: "2",
  class: "onboard-step"
}
const _hoisted_6 = {
  key: "3",
  class: "onboard-step"
}
const _hoisted_7 = {
  key: "4",
  class: "onboard-step"
}
const _hoisted_8 = {
  key: "5",
  class: "onboard-step"
}
const _hoisted_9 = { class: "onboard-nav" }
const _hoisted_10 = {
  key: 1,
  class: "onboard-step-label"
}
const _hoisted_11 = { class: "onboard-dots" }
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "onboard-overlay",
      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.$emit('dismiss')), ["self"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "onboard-progress-fill",
            style: _normalizeStyle({ width: ((_ctx.step / _ctx.totalSteps) * 100) + '%' })
          }, null, 4)
        ]),
        _createVNode(_Transition, {
          name: "slide",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_ctx.step === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "onboard-icon" }, "🏗️", -1)),
                  _createElementVNode("h2", null, "Bem-vindo ao " + _toDisplayString(_ctx.systemName) + "!", 1),
                  _cache[11] || (_cache[11] = _createElementVNode("p", null, "Vamos configurar o seu sistema em poucos passos. Isso leva menos de 2 minutos.", -1)),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["check-item", { done: _ctx.hasSiteConfig }])
                    }, [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("span", { class: "check-dot" }, null, -1),
                      _createTextVNode(" Personalizar nome e visual ", -1)
                    ]))], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["check-item", { done: _ctx.hasProject }])
                    }, [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("span", { class: "check-dot" }, null, -1),
                      _createTextVNode(" Criar primeiro projeto ", -1)
                    ]))], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["check-item", { done: _ctx.hasUser }])
                    }, [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("span", { class: "check-dot" }, null, -1),
                      _createTextVNode(" Adicionar ou convidar usuários ", -1)
                    ]))], 2)
                  ])
                ]))
              : (_ctx.step === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "onboard-icon" }, "🎨", -1)),
                    _cache[14] || (_cache[14] = _createElementVNode("h2", null, "Configure o sistema", -1)),
                    _cache[15] || (_cache[15] = _createElementVNode("p", null, [
                      _createTextVNode("Acesse "),
                      _createElementVNode("strong", null, "Gerenciar Sistema"),
                      _createTextVNode(" na barra lateral para definir o nome da obra, logo e cores personalizadas.")
                    ], -1)),
                    _createElementVNode("div", {
                      class: "onboard-action-card",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('go-to', 'manage-system')))
                    }, [...(_cache[12] || (_cache[12] = [
                      _createElementVNode("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none"
                      }, [
                        _createElementVNode("circle", {
                          cx: "10",
                          cy: "10",
                          r: "3",
                          stroke: "currentColor",
                          "stroke-width": "1.5"
                        }),
                        _createElementVNode("path", {
                          d: "M10 1v2M10 17v2M1 10h2M17 10h2M3.22 3.22l1.42 1.42M15.36 15.36l1.42 1.42M3.22 16.78l1.42-1.42M15.36 4.64l1.42-1.42",
                          stroke: "currentColor",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round"
                        })
                      ], -1),
                      _createTextVNode(" Ir para Gerenciar Sistema ", -1)
                    ]))])
                  ]))
                : (_ctx.step === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "onboard-icon" }, "📋", -1)),
                      _cache[18] || (_cache[18] = _createElementVNode("h2", null, "Crie seu primeiro projeto", -1)),
                      _cache[19] || (_cache[19] = _createElementVNode("p", null, "Projetos são o centro do sistema. Cada obra tem seu próprio Gantt, equipe, almoxarifado e relatórios.", -1)),
                      _createElementVNode("div", {
                        class: "onboard-action-card",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('go-to', 'manage-projects')))
                      }, [...(_cache[16] || (_cache[16] = [
                        _createElementVNode("svg", {
                          width: "20",
                          height: "20",
                          viewBox: "0 0 20 20",
                          fill: "none"
                        }, [
                          _createElementVNode("rect", {
                            x: "2",
                            y: "3",
                            width: "16",
                            height: "14",
                            rx: "2",
                            stroke: "currentColor",
                            "stroke-width": "1.5"
                          }),
                          _createElementVNode("path", {
                            d: "M7 10h6M10 7v6",
                            stroke: "currentColor",
                            "stroke-width": "1.5",
                            "stroke-linecap": "round"
                          })
                        ], -1),
                        _createTextVNode(" Ir para Gerenciar Projetos ", -1)
                      ]))])
                    ]))
                  : (_ctx.step === 4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "onboard-icon" }, "👥", -1)),
                        _cache[22] || (_cache[22] = _createElementVNode("h2", null, "Adicione sua equipe", -1)),
                        _cache[23] || (_cache[23] = _createElementVNode("p", null, "Convide colaboradores por e-mail ou crie contas diretamente. Defina papéis e cargos para cada pessoa.", -1)),
                        _createElementVNode("div", {
                          class: "onboard-action-card",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('go-to', 'manage-users')))
                        }, [...(_cache[20] || (_cache[20] = [
                          _createElementVNode("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none"
                          }, [
                            _createElementVNode("circle", {
                              cx: "8",
                              cy: "7",
                              r: "3",
                              stroke: "currentColor",
                              "stroke-width": "1.5"
                            }),
                            _createElementVNode("path", {
                              d: "M2 17c0-3.314 2.686-6 6-6M14 11v6M11 14h6",
                              stroke: "currentColor",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round"
                            })
                          ], -1),
                          _createTextVNode(" Ir para Gerenciar Usuários ", -1)
                        ]))])
                      ]))
                    : (_ctx.step === 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[24] || (_cache[24] = [
                          _createElementVNode("div", { class: "onboard-icon" }, "✅", -1),
                          _createElementVNode("h2", null, "Tudo pronto!", -1),
                          _createElementVNode("p", null, "Seu sistema está configurado. Explore o painel, crie tarefas no Gantt e acompanhe o progresso da obra em tempo real.", -1),
                          _createElementVNode("div", { class: "onboard-tips" }, [
                            _createElementVNode("div", { class: "tip-item" }, [
                              _createElementVNode("span", { class: "tip-key" }, "Dica"),
                              _createTextVNode(" Use o Gantt para planejar tarefas com dependências e prazos. ")
                            ]),
                            _createElementVNode("div", { class: "tip-item" }, [
                              _createElementVNode("span", { class: "tip-key" }, "Dica"),
                              _createTextVNode(" Envie RDOs diários pela tela de Relatórios. ")
                            ]),
                            _createElementVNode("div", { class: "tip-item" }, [
                              _createElementVNode("span", { class: "tip-key" }, "Dica"),
                              _createTextVNode(" O Almoxarifado controla ferramentas e equipamentos por tarefa. ")
                            ])
                          ], -1)
                        ]))]))
                      : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.step > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "onboard-btn-ghost",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.step--))
              }, "Voltar"))
            : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.step) + " / " + _toDisplayString(_ctx.totalSteps), 1)),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalSteps, (i) => {
              return (_openBlock(), _createElementBlock("span", {
                key: i,
                class: _normalizeClass(["onboard-dot", { active: i === _ctx.step }]),
                onClick: ($event: any) => (_ctx.step = i)
              }, null, 10, _hoisted_12))
            }), 128))
          ]),
          (_ctx.step < _ctx.totalSteps)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "onboard-btn-primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.step++))
              }, "Próximo"))
            : (_openBlock(), _createElementBlock("button", {
                key: 3,
                class: "onboard-btn-primary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('dismiss')))
              }, "Começar"))
        ])
      ])
    ])
  ]))
}